import React from 'react';
import { cn } from '../../lib/utils';
import { FinancialAmount, DocumentReference } from '../../design-system/components/FinancialAmount';
import { StatusBadge as DesignStatusBadge } from '../../design-system/components/StatusBadge';

const STATUS_LABELS = {
  draft: 'مسودة', pending: 'قيد الانتظار', submitted: 'مرسل', sent: 'مرسل', approved: 'معتمد', confirmed: 'مؤكد',
  rejected: 'مرفوض', ordered: 'مطلوب', partially_received: 'مستلم جزئياً', partial: 'مستلم جزئياً', received: 'مستلم',
  completed: 'مكتمل', cancelled: 'ملغي', active: 'نشط', inactive: 'غير نشط', archived: 'مؤرشف', posted: 'مرحّل',
  unpaid: 'غير مدفوع', partially_paid: 'مدفوع جزئياً', paid: 'مدفوع', suspended: 'معلّق', blocked: 'محظور',
};

export const SupplierReference = ({ value, children, className = '' }) => (
  <DocumentReference dir="ltr" className={cn('font-mono tabular-nums text-primary-700 dark:text-primary-300', className)}>
    {children || value || '—'}
  </DocumentReference>
);

export const WarehouseReference = ({ value, children, className = '' }) => (
  <DocumentReference dir="ltr" className={cn('font-mono tabular-nums text-primary-700 dark:text-primary-300', className)}>
    {children || value || '—'}
  </DocumentReference>
);

export const QuantityDisplay = ({ value, unit = '', className = '' }) => (
  <span dir="ltr" className={cn('font-mono tabular-nums text-neutral-900 dark:text-neutral-100', className)}>
    {new Intl.NumberFormat('en-US', { maximumFractionDigits: 3 }).format(Number(value) || 0)}{unit ? ` ${unit}` : ''}
  </span>
);

export const ProcurementFinancialAmount = ({ value, currency = 'AED', className = '' }) => (
  <FinancialAmount value={value} currency={currency} className={cn('font-mono tabular-nums', className)} />
);

export const ProcurementStatusBadge = ({ status, label, className = '' }) => (
  <DesignStatusBadge status={status || 'unknown'} label={label || STATUS_LABELS[status] || status || 'غير محدد'} className={className} />
);

export const ReceivingProgress = ({ received = 0, ordered = 0, className = '' }) => {
  const total = Number(ordered) || 0;
  const done = Math.max(0, Number(received) || 0);
  const percent = total > 0 ? Math.min(100, Math.round((done / total) * 100)) : 0;
  return (
    <div className={cn('min-w-[9rem]', className)} aria-label={`تم استلام ${percent}%`}>
      <div className="mb-1 flex items-center justify-between text-[11px] text-neutral-500 dark:text-neutral-400">
        <span>الاستلام</span>
        <span dir="ltr" className="font-mono tabular-nums">{percent}%</span>
      </div>
      <div className="h-2 rounded-full bg-primary-100 dark:bg-primary-950/40">
        <div className="h-2 rounded-full bg-primary-600" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};
